export default __webpack_public_path__ + "static/media/winrar-icon-11609382824mrjqb0ypjb.5227bc68.png";